module.exports = __webpack_public_path__ + "static/media/平安证券@2x.9ffc096c.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_171/images/平安证券@2x.png
// module id = 1545
// module chunks = 0